import { Logo } from '@/components/brand/Logo';

/**
 * Branded maintenance screen — BUILD-PLAN §24/§67.
 *
 * §24 requires visitors receive "a polished maintenance screen rather than an
 * application error". Scoped maintenance (store, checkout, accounts) renders
 * this inside the normal layout; full maintenance replaces the whole page.
 */

interface MaintenancePageProps {
  title?: string;
  description?: string;
  fullScreen?: boolean;
}

export function MaintenancePage({
  title = 'We’re Making Things Beautiful',
  description = 'Glanz Luxe is briefly unavailable while we make some improvements. We’ll be back very shortly.',
  fullScreen = true,
}: MaintenancePageProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center px-6 text-center ${
        fullScreen ? 'min-h-screen bg-background' : 'py-24'
      }`}
      role="status"
      aria-live="polite"
    >
      <Logo size="lg" decorative />

      <h1 className="mt-10 max-w-xl font-display text-3xl leading-tight text-ink">
        {title}
      </h1>

      <p className="mt-4 max-w-md text-sm leading-relaxed text-muted">
        {description}
      </p>

      <p className="mt-12 font-display text-lg italic text-accent">
        Made with Purpose. Packaged with Love.
      </p>
    </div>
  );
}
